module.exports = __webpack_public_path__ + "img/s3-2.2455a0c2.jpg";